var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMotor = function SvgMotor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 508.876 508.876"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m508.876 158.373-45-.37v259.499h45zM398.101 218.831l-53.987-61.006h-69.186v-36.451h71.79v-30h-173.58v30h71.79v36.451h-72.023l-35.319 41.365H66.662v70.948H30v-60.085H0v152.474h30v-62.389h36.662v75.032h71.013l36.229 38.348 170.194-.102 54.472-60.506h35.306V218.83h-35.775zM276.588 359.415h-30v-33.512h30zm0-61.414h-30v-91.06h30z"
  })));
};
export default SvgMotor;